module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"Back":"Voltar","newVersion":"Está disponível uma nova versão desta aplicação. Clique aqui para actualizar."},"es":{"Back":"Volver","newVersion":"Una nueva versión de esta aplicación está disponible. Haga clic aquí para actualizar."}}')
  delete Component.options._Ctor
}
